// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slideAdministrar {
  margin-bottom: 10px;
  font-weight: 500;
}

.fila1 {
  width: 100%;
}
.fila1 table tr {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.fila1 table tr h1 {
  padding-left: 0px;
}

.col1 h1 {
  width: 100%;
  text-align: initial;
  color: #333;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  font-size: 25px;
  display: ruby-text-container;
}

.col2,
.col3,
.col1-3,
.col4,
.col5,
.col6 {
  text-align: end;
  cursor: pointer;
}

.col6 {
  margin-top: -9px;
}

table {
  width: 100%;
}

.mat {
  width: 100%;
  margin-bottom: 10px;
}

.mat ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px !important;
}

.animacion {
  width: 100%;
  height: 90px;
}

.ocultar {
  display: none !important;
}

.tablaUsuarios {
  border: 1px solid #cecece;
}

.inputBusqueda {
  border-bottom: 2px solid #5b7f30;
}

.iconoBusqueda {
  color: #8bc34a;
  cursor: pointer;
  padding-left: 8px;
  width: 100%;
}

.matFile {
  width: 100%;
}

.titulotabla {
  text-align: center;
  color: #333;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  display: ruby-text-container;
  width: 100%;
}

.divheader {
  width: 100%;
  text-align: start;
}

::ng-deep .mat-sort-header-button {
  width: 100% !important;
}

.mat ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -webkit-appearance: textfield;
          appearance: textfield;
}

.content {
  padding: 16px 32px;
}
.content .tablaMunicipios {
  border: 1px solid #cecece;
}
.content .tablaMunicipios table {
  table-layout: fixed;
}
.content .tablaMunicipios tr {
  text-align: center;
}
.content .tablaMunicipios th {
  font-weight: 500;
}
.content .tablaMunicipios th #text {
  width: 100%;
}
.content .titulotabla {
  width: 100%;
  text-align: center;
  color: #333;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  display: ruby-text-container;
}
.content .titulotabla .divheader {
  width: 100%;
  text-align: start;
}
.content .matFile {
  width: 100%;
}

/* responsive desgin */
@media (max-width: 768px) {
  .col1 h1 {
    font-size: 14px;
  }
  .content {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/conf-municipio/conf-municipio.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;AAEQ;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;AAAZ;AAEY;EACI,iBAAA;AAAhB;;AAMA;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,+EAAA;EACA,eAAA;EACA,4BAAA;AAHJ;;AAMA;;;;;;EAMI,eAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;EACA,mBAAA;AAHJ;;AAOA;EACI,8BAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;AAJJ;;AAOA;EACI,wBAAA;AAJJ;;AAOA;EACI,yBAAA;AAJJ;;AAOA;EACI,gCAAA;AAJJ;;AAOA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,WAAA;EACA,+EAAA;EACA,4BAAA;EACA,WAAA;AAJJ;;AAOA;EACI,WAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,sBAAA;AAJJ;;AAQA;EACI,8BAAA;AALJ;;AAQA;;EAEI,wBAAA;EACA,SAAA;AALJ;;AASA,YAAA;AAEA;EAEI,6BAAA;UAAA,qBAAA;AAPJ;;AAUA;EACI,kBAAA;AAPJ;AAQI;EACI,yBAAA;AANR;AAOQ;EACI,mBAAA;AALZ;AAOQ;EACI,kBAAA;AALZ;AAOQ;EACI,gBAAA;AALZ;AAMY;EACI,WAAA;AAJhB;AAQI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,+EAAA;EACA,4BAAA;AANR;AAOQ;EACI,WAAA;EACA,iBAAA;AALZ;AAQI;EACI,WAAA;AANR;;AAUA,sBAAA;AACA;EAEI;IACI,eAAA;EARN;EAWE;IACI,aAAA;EATN;AACF","sourcesContent":[".slideAdministrar {\r\n    margin-bottom: 10px;\r\n    font-weight: 500;\r\n}\r\n\r\n.fila1 {\r\n    width: 100%;\r\n\r\n    table {\r\n        tr {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: flex-end;\r\n\r\n            h1 {\r\n                padding-left: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.col1 h1 {\r\n    width: 100%;\r\n    text-align: initial;\r\n    color: #333;\r\n    font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n    font-size: 25px;\r\n    display: ruby-text-container;\r\n}\r\n\r\n.col2,\r\n.col3,\r\n.col1-3,\r\n.col4,\r\n.col5,\r\n.col6 {\r\n    text-align: end;\r\n    cursor: pointer;\r\n}\r\n\r\n.col6 {\r\n    margin-top: -9px;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n}\r\n\r\n.mat {\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n\r\n.mat ::ng-deep .mat-form-field-wrapper {\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\n.animacion {\r\n    width: 100%;\r\n    height: 90px;\r\n}\r\n\r\n.ocultar {\r\n    display: none !important;\r\n}\r\n\r\n.tablaUsuarios {\r\n    border: 1px solid #cecece;\r\n}\r\n\r\n.inputBusqueda {\r\n    border-bottom: 2px solid #5b7f30;\r\n}\r\n\r\n.iconoBusqueda {\r\n    color: #8bc34a;\r\n    cursor: pointer;\r\n    padding-left: 8px;\r\n    width: 100%;\r\n}\r\n\r\n.matFile {\r\n    width: 100%;\r\n}\r\n\r\n.titulotabla {\r\n    text-align: center;\r\n    color: #333;\r\n    font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n    display: ruby-text-container;\r\n    width: 100%;\r\n}\r\n\r\n.divheader {\r\n    width: 100%;\r\n    text-align: start;\r\n}\r\n\r\n::ng-deep .mat-sort-header-button {\r\n    width: 100% !important;\r\n}\r\n\r\n\r\n.mat ::ng-deep .mat-form-field-wrapper {\r\n    padding-bottom: 0px !important;\r\n}\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n\r\n/* Firefox */\r\n\r\ninput[type=number] {\r\n    -moz-appearance: textfield;\r\n    appearance: textfield;\r\n}\r\n\r\n.content{\r\n    padding: 16px 32px;\r\n    .tablaMunicipios {\r\n        border: 1px solid #cecece;\r\n        table{\r\n            table-layout: fixed;\r\n        }\r\n        tr{\r\n            text-align: center;\r\n        }\r\n        th{\r\n            font-weight: 500;\r\n            #text{\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n    .titulotabla {\r\n        width: 100%;\r\n        text-align: center;\r\n        color: #333;\r\n        font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n        display: ruby-text-container;\r\n        .divheader {\r\n            width: 100%;\r\n            text-align: start;\r\n        }\r\n    }\r\n    .matFile {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n/* responsive desgin */\r\n@media (max-width: 768px) {\r\n\r\n    .col1 h1 {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .content {\r\n        padding: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
